export default "__VITE_PUBLIC_ASSET__cdb2dd95__"